import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowInboundWebhookTestRequest,
  WorkflowWebhookEndpointCreateRequest,
  WorkflowWebhookEndpointResponse,
  WorkflowWebhookEndpointUpdateRequest,
  WorkflowWebhookPreviewRequest,
  WorkflowWebhookPreviewResponse,
  WorkflowWebhookRenderRequest,
  WorkflowWebhookRenderResponse,
  WorkflowWebhookTestRequest,
  WorkflowWebhookTestResponse
} from '../models/workflow-webhook-action.model';

@Injectable({ providedIn: 'root' })
export class WorkflowWebhookActionApiService {
  private readonly actionsUrl = `${environment.apiUrl}api/workflow-actions`;
  private readonly webhooksUrl = `${environment.apiUrl}api/workflow-webhooks`;

  constructor(private http: HttpClient) {}

  test(request: WorkflowWebhookTestRequest): Observable<WorkflowWebhookTestResponse> {
    return this.http.post<WorkflowWebhookTestResponse>(
      `${this.actionsUrl}/webhook/test`,
      request
    );
  }

  preview(request: WorkflowWebhookPreviewRequest): Observable<WorkflowWebhookPreviewResponse> {
    return this.http.post<WorkflowWebhookPreviewResponse>(
      `${this.actionsUrl}/webhook/preview`,
      request
    );
  }

  render(request: WorkflowWebhookRenderRequest): Observable<WorkflowWebhookRenderResponse> {
    return this.http.post<WorkflowWebhookRenderResponse>(
      `${this.actionsUrl}/webhook/render`,
      request
    );
  }

  listEndpoints(): Observable<WorkflowWebhookEndpointResponse[]> {
    return this.http.get<WorkflowWebhookEndpointResponse[]>(
      `${this.webhooksUrl}/endpoints`
    );
  }

  getEndpoint(id: number): Observable<WorkflowWebhookEndpointResponse> {
    return this.http.get<WorkflowWebhookEndpointResponse>(
      `${this.webhooksUrl}/endpoints/${id}`
    );
  }

  createEndpoint(request: WorkflowWebhookEndpointCreateRequest): Observable<WorkflowWebhookEndpointResponse> {
    return this.http.post<WorkflowWebhookEndpointResponse>(
      `${this.webhooksUrl}/endpoints`,
      request
    );
  }

  updateEndpoint(id: number, request: WorkflowWebhookEndpointUpdateRequest): Observable<WorkflowWebhookEndpointResponse> {
    return this.http.put<WorkflowWebhookEndpointResponse>(
      `${this.webhooksUrl}/endpoints/${id}`,
      request
    );
  }

  deleteEndpoint(id: number): Observable<void> {
    return this.http.delete<void>(
      `${this.webhooksUrl}/endpoints/${id}`
    );
  }

  testInbound(request: WorkflowInboundWebhookTestRequest): Observable<any> {
    let headers = new HttpHeaders();
    if (request.secret) {
      headers = headers.set('X-Webhook-Secret', request.secret);
    }
    return this.http.post<any>(
      `${this.webhooksUrl}/inbound/${request.endpointKey}`,
      request.payload,
      { headers }
    );
  }
}
